import React from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";

import * as selectors from '../application.selectors';

const BreadCrumbs = ({crumbs}) => (
  <ol className="breadcrumb">
    {crumbs.map(({active, title, to}) => (
      <li key={title} className={active ? 'active' : ''}>
        {active ? title : <Link to={to}>{title}</Link>}
      </li>
    ))}
  </ol>
);

export default connect(
  state => ({
    crumbs: selectors.breadCrumbs(state)
  })
)(BreadCrumbs);




// WEBPACK FOOTER //
// ./src/components/BreadCrumbs.js